import React, { Component } from 'react'
import _ from 'lodash'
import Link from 'gatsby-link'
import Button from '../CustomButtons/Button.jsx'

class PostTags extends Component {
  render() {
    const { tags } = this.props
    return (
      <div className="post-tag-container">
        {tags && (
          <Button round simple size="sm">
            {tags}
          </Button>
        )}
      </div>
    )
  }
}

export default PostTags



// WEBPACK FOOTER //
// ./src/components/PostTags/PostTags.jsx